<h2 mat-dialog-title>Shared billing usage</h2>
<mat-dialog-content>
    <p>Select a period in your local time. Usage includes the start time and excludes the end time.</p>
<form class="flex flex-col gap-4" (submit)="loadUsage($event)">
  <div class="grid gap-4 md:grid-cols-2">
    <fieldset class="border-outline grid gap-4 rounded border border-solid p-4 sm:grid-cols-2">
      <legend class="px-2 font-medium">Start</legend>

      <mat-form-field class="w-full">
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" [formField]="periodForm.startDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>

        @for (error of periodForm.startDate().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Start time (inclusive)</mat-label>
        <input matInput [matTimepicker]="startTimePicker" [formField]="periodForm.startTime">
        <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"></mat-timepicker-toggle>
        <mat-timepicker #startTimePicker></mat-timepicker>

        @for (error of periodForm.startTime().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>
    </fieldset>

    <fieldset class="border-outline grid gap-4 rounded border border-solid p-4 sm:grid-cols-2">
      <legend class="px-2 font-medium">End</legend>

      <mat-form-field class="w-full">
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [formField]="periodForm.endDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>

        @for (error of periodForm.endDate().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>End time (exclusive)</mat-label>
        <input matInput [matTimepicker]="endTimePicker" [formField]="periodForm.endTime">
        <mat-timepicker-toggle matIconSuffix [for]="endTimePicker"></mat-timepicker-toggle>
        <mat-timepicker #endTimePicker></mat-timepicker>

        @for (error of periodForm.endTime().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>
    </fieldset>
  </div>

  <div>
    <button matButton="filled"
            type="submit"
            [disabled]="!periodForm().valid() || periodForm().submitting()">
      <mat-icon>refresh</mat-icon>
      {{periodForm().submitting() ? 'Loading...' : 'Load Usage'}}
    </button>
  </div>
</form>

    @if (periodForm().submitting()) {
        <mat-progress-bar mode="indeterminate" aria-label="Loading shared billing usage" />
    } @else if (loadError()) {
        <p class="py-4" role="alert">Unable to load shared billing usage. {{ loadError() }}</p>
    } @else if (loadedPeriod(); as period) {
        <p class="mt-4">Usage from {{ period.start | date:'medium' }} to {{ period.end | date:'medium' }}.</p>
        @if (rows().length) {
            <div class="overflow-x-auto">
                <table mat-table [dataSource]="rows()" aria-label="Shared billing usage">
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
                    </ng-container>
                    <ng-container matColumnDef="credits">
                        <th mat-header-cell *matHeaderCellDef>Credits used</th>
                        <td mat-cell *matCellDef="let row">{{ row.credits | number }}</td>
                    </ng-container>
                    <ng-container matColumnDef="percent">
                        <th mat-header-cell *matHeaderCellDef>% of total</th>
                        <td mat-cell *matCellDef="let row">{{ row.percent | percent:'1.1-1' }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columns"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns"></tr>
                </table>
            </div>
        } @else {
            <p>No shared billing usage was found for this period.</p>
        }
        <p class="mt-4"><strong>Total credits used: {{ totalCredits() | number }}</strong></p>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton type="button" mat-dialog-close>Close</button>
</mat-dialog-actions>
